import React from 'react';
import splitViewManager from '../utilities/splitViewManager';

//splitview2画面のの開閉を管理する
export default class SplitViewWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      split: [true, false],
    };

    //分割画面の変更通知
    splitViewManager.setDelegate(split => {
      this.setState({ split });
    });

    //分割画面の強制変更通知
    splitViewManager.setForceDelegate(() => {
      this.setState({ split: [true, false] });
    });
  }

  componentDidMount() {
    this.setState({ split: [true, false] });
  }

  classname() {
    const view1 = this.state.split[0] ? '1' : '0';
    const view2 = this.state.split[1] ? '1' : '0';
    return `splitview split--${view1}-${view2}`;
  }

  render() {
    return (
      <div id='splitview' className={this.classname()}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/splitViewWrapper.js